import { render } from "./CampaignLeaderboard.vue?vue&type=template&id=5697e4a7&scoped=true"
import script from "./CampaignLeaderboard.vue?vue&type=script&lang=js"
export * from "./CampaignLeaderboard.vue?vue&type=script&lang=js"

import "./CampaignLeaderboard.vue?vue&type=style&index=0&id=5697e4a7&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5697e4a7"]])

export default __exports__